var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HistamineModal'),_c('div',_vm._l((_vm.currentItems),function(item,index){return _c('HistamineItem',{key:index + item.name,attrs:{"searchTerm":_vm.searchInput,"itemData":item}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }